import React, { useState } from 'react';
import { 
  Grid, Card, CardContent, CardActions, Typography, List, ListItem, 
  ListItemIcon, ListItemText, Button, CircularProgress, Tabs, Tab, Box
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PLAN_TYPE } from '../../constants/subscriptionTypes';

export default function CombinedPremiumPlan({ subscription, monthlyLoading, annualLoading, handleSubscribe }) {
  const [tabValue, setTabValue] = useState(1); // Start with Annual plan (index 1) selected
  
  const isMonthly = subscription?.type === PLAN_TYPE.MONTHLY;
  const isAnnual = subscription?.type === PLAN_TYPE.YEARLY;
  
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Grid item xs={12} md={8}>
      <Card variant="outlined">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            aria-label="subscription plan tabs"
            variant="fullWidth"
          >
            <Tab label="Monthly" />
            <Tab label="Annual (Save 33%)" />
          </Tabs>
        </Box>
        
        {/* Monthly Plan Tab */}
        <div role="tabpanel" hidden={tabValue !== 0}>
          {tabValue === 0 && (
            <>
              <CardContent>
                <Typography variant="h6" gutterBottom>Premium Plan (Monthly)</Typography>
                <Typography variant="h4">£2.99<Typography variant="caption">/month</Typography></Typography>
                <List dense>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="All Features of the Free Plan"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="Unlimited Bookmarks Saving and Retrieve"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="Generate Unlimited Presentations"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="24-hour email support"/></ListItem>
                </List>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  fullWidth
                  color={isMonthly ? 'success' : 'primary'}
                  onClick={() => handleSubscribe('monthly')}
                  disabled={monthlyLoading || isMonthly}
                >
                  {monthlyLoading ? <CircularProgress size={24}/> : isMonthly ? 'Current Plan' : 'Subscribe Monthly'}
                </Button>
              </CardActions>
            </>
          )}
        </div>
        
        {/* Annual Plan Tab */}
        <div role="tabpanel" hidden={tabValue !== 1}>
          {tabValue === 1 && (
            <>
              <CardContent>
                <Typography variant="h6" gutterBottom>Premium Plan (Annual)</Typography>
                <Typography variant="h4">£1.99<Typography variant="caption">/month</Typography></Typography>
                <Typography variant="subtitle2" color="primary" sx={{ mb: 1 }}>1-month free trial</Typography>
                <List dense>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="All Features of the Free Plan"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="Unlimited Bookmarks Saving and Retrieve"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="Generate Unlimited Presentations"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="24-hour email support"/></ListItem>
                  <ListItem><ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon><ListItemText primary="33% discount vs the Monthly plan"/></ListItem>
                </List>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  fullWidth
                  color={isAnnual ? 'success' : 'primary'}
                  onClick={() => handleSubscribe('annual')}
                  disabled={annualLoading || isAnnual}
                >
                  {annualLoading ? <CircularProgress size={24}/> : isAnnual ? 'Current Plan' : 'Subscribe Annual'}
                </Button>
              </CardActions>
            </>
          )}
        </div>
      </Card>
    </Grid>
  );
}
